import type { ReactNode } from "react";

type ErrorFlashProps = {
  message: ReactNode;
};

export function ErrorFlash({ message }: ErrorFlashProps) {
  if (!message) return null;
  return (
    <div className="flash flash--error flash--appear" role="alert">
      {message}
    </div>
  );
}
